// extracted by mini-css-extract-plugin
export default {"container":"CreateEditPane_container__zMgpY","form":"CreateEditPane_form__rkatU","bottom":"CreateEditPane_bottom__x82ng"};